import React, { memo } from 'react';
import { StyleSheet, Text } from 'react-native';
import LinearGradient from 'utils/packages/linearGradient';
import { rem } from 'design-system';
import { isDefaultCategory, useCategories } from 'hooks/useCategory';
import useColors from 'hooks/useColors';
import IconCategoryBusiness from './categories/IconCategoryBusiness';
import IconCategoryCash from './categories/IconCategoryCash';
import IconCategoryCharity from './categories/IconCategoryCharity';
import IconCategoryEatingOut from './categories/IconCategoryEatingOut';
import IconCategoryEducation from './categories/IconCategoryEducation';
import IconCategoryEntertainment from './categories/IconCategoryEntertainment';
import IconCategoryIncome from './categories/IconCategoryIncome';
import IconCategoryFamily from './categories/IconCategoryFamily';
import IconCategoryGeneral from './categories/IconCategoryGeneral';
import IconCategoryGroceries from './categories/IconCategoryGroceries';
import IconCategoryPersonalCare from './categories/IconCategoryPersonalCare';
import IconCategoryHolidays from './categories/IconCategoryHolidays';
import IconCategoryHousing from './categories/IconCategoryHousing';
import IconCategoryInvestments from './categories/IconCategoryInvestments';
import IconCategoryShopping from './categories/IconCategoryShopping';
import IconCategoryTransport from './categories/IconCategoryTransport';
import IconCategoryExcluded from './categories/IconCategoryExcluded';
import IconCategoryBills from './categories/IconCategoryBills';
import IconCategoryTransfer from './categories/IconCategoryTransfer';
const IconTransactionCategory = ({ category, style, width = rem(24), height = rem(24), color, emojiBackgroundColor, children, lightBackground, }) => {
    const categories = useCategories();
    const colors = useColors();
    // NOTE: not using custom category color
    let fillColor;
    if (color) {
        fillColor = color;
    }
    else if (category?.id && isDefaultCategory(category.id)) {
        fillColor = categories[category.id].color;
    }
    const props = {
        width,
        height,
        style,
        viewBox: '0 0 25 24',
        fill: fillColor,
    };
    switch (category?.id) {
        case 'bills':
            return <IconCategoryBills {...props}/>;
        case 'business':
            return <IconCategoryBusiness {...props}/>;
        case 'cash':
            return <IconCategoryCash {...props}/>;
        case 'charity':
            return <IconCategoryCharity {...props}/>;
        case 'eatingout':
            return <IconCategoryEatingOut {...props} viewBox="0 0 25 25"/>;
        case 'education':
            return <IconCategoryEducation {...props}/>;
        case 'entertainment':
            return <IconCategoryEntertainment {...props}/>;
        case 'family':
            return <IconCategoryFamily {...props}/>;
        case 'general':
            return <IconCategoryGeneral {...props}/>;
        case 'groceries':
            return <IconCategoryGroceries {...props}/>;
        case 'health':
            return <IconCategoryPersonalCare {...props}/>;
        case 'holidays':
            return <IconCategoryHolidays {...props}/>;
        case 'housing':
            return <IconCategoryHousing {...props}/>;
        case 'income':
            return <IconCategoryIncome {...props}/>;
        case 'internal':
            return <IconCategoryExcluded {...props}/>;
        case 'investments':
            return <IconCategoryInvestments {...props}/>;
        case 'shopping':
            return <IconCategoryShopping {...props}/>;
        case 'transport':
            return <IconCategoryTransport {...props}/>;
        case 'transfer':
            return <IconCategoryTransfer {...props}/>;
        default: {
            let backgroundColor = emojiBackgroundColor
                ? [emojiBackgroundColor, emojiBackgroundColor]
                : undefined;
            if (!backgroundColor) {
                backgroundColor = [colors.background.dark, colors.background.dark];
            }
            if (lightBackground) {
                backgroundColor = [colors.cards.onDark, colors.cards.onDark];
            }
            return (<>
          {backgroundColor ? (<LinearGradient style={styles.background} colors={backgroundColor}/>) : null}
          {category?.emoji ? (<Text style={[
                        styles.emoji,
                        {
                            fontSize: Number(width) * 0.8,
                            lineHeight: Number(width),
                        },
                    ]}>
              {category.emoji}
            </Text>) : null}
          {children}
        </>);
        }
    }
};
const styles = StyleSheet.create({
    emoji: {
        fontFamily: 'System',
        textAlign: 'center',
        color: 'black',
    },
    background: {
        width: '100%',
        position: 'absolute',
        height: '100%',
        borderRadius: 100,
    },
});
export default memo(IconTransactionCategory);
